module.exports = __webpack_public_path__ + "static/biennale-hair-b539856669a3590fe6e49a8184ceca1e.otf";